import BaseComponent from "../../../baseComponent.js";
import BulletWidget from "../../widgets/bullet/bulletWidget.jsx";

export default class Bullet extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }
    return (
      <BulletWidget widget={this.props.model} widgetId={this.props.model.id}
                    isAddWidget={true}
                    legends={this.props.model.legends}
                    togglePreloader={() => true}
                    componentId={component.controller.id}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/bullet.jsx